<template>
  <div class="flight-pad-details-bags">
    <div>
      <div class="h5 mb-0 semibold">Bagagli inclusi nella tariffa</div>
      <p class="flight-pad-details-bags__description">
        Per ogni passeggero adulto. Verifica nel box
        <span class="bold">La tua scelta</span> il numero complessivo dei bagagli inclusi e se sono
        inclusi anche per bambini e neonati. Verifica sempre le condizioni e le franchigie sul sito
        della compagnia aerea. Il conteggio non considera i bagagli aggiuntivi acquistati.
      </p>
    </div>
    <div>
      <div
        class="flight-pad-details-bags__title"
        :style="{ color: bags_quantity_color(hand_bags) }"
      >
        <span v-html="svg_backpack(bags_quantity_color(hand_bags), 20, 20)"></span>
        <span>
          <span
            class="semibold"
            :style="{
              'padding-bottom': '2.5px',
              color: bags_quantity_color(hand_bags, '#35A8E0'),
            }"
          >
            {{ hand_bags }}
          </span>
          Bagagli{{ hand_bags === 1 ? 'o' : '' }} personal{{ hand_bags === 1 ? 'e' : 'i' }}
        </span>
      </div>
      <p class="flight-pad-details-bags__description">
        Piccolo, va sotto il sedile. Per ogni passeggero adulto.
      </p>
    </div>
    <div>
      <div
        class="flight-pad-details-bags__title"
        :style="{ color: bags_quantity_color(luggage_bags) }"
      >
        <span v-html="svg_luggage(bags_quantity_color(luggage_bags), 20, 30)"></span>
        <span>
          <span
            class="semibold"
            :style="{
              color: bags_quantity_color(luggage_bags, '#35A8E0'),
            }"
          >
            {{ luggage_bags }}
          </span>
          Bagagli{{ luggage_bags === 1 ? 'o' : '' }} da stiva
        </span>
      </div>
      <p class="flight-pad-details-bags__description">
        Si consegna al check-in e viaggia in stiva. È il numero di bagagli in stiva inclusi per ogni
        passeggero adulto.
      </p>
    </div>
  </div>
</template>

<script>
import { backpack, luggage } from '@/components/svg/bags';
import { bags_quantity_color, hand_bags_per_adult, luggage_bags_per_adult } from '../utilities';

export default {
  name: 'flight-pad-details-bags',
  props: {
    flight_offer: Object,
  },
  computed: {
    hand_bags() {
      return hand_bags_per_adult(this.flight_offer);
    },
    luggage_bags() {
      return luggage_bags_per_adult(this.flight_offer);
    },
  },
  methods: {
    svg_backpack: backpack,
    svg_luggage: luggage,
    bags_quantity_color,
  },
};
</script>

<style lang="scss" scoped>
.flight-pad-details-bags {
  line-height: unset;
  padding: 30px 0 25px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__description {
    color: $dark-gray;
    margin: 0;
    margin-top: 0.25rem;
    font-size: 12px;
  }

  &__title {
    line-height: unset;
    &__icon {
      line-height: normal;
    }
    font-size: 16px;
    display: flex;
    align-items: flex-end;
    gap: 5px;
  }
}
</style>
